var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 49,
    viewBox: "0 0 53 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3195 9.59952H18.9611C18.0481 9.59952 17.3081 10.4142 17.3081 11.4194C17.3081 12.4246 18.048 13.2393 18.9611 13.2393H29.3195C30.233 13.2393 30.9725 12.4247 30.9725 11.4194C30.9724 10.4142 30.2325 9.59952 29.3195 9.59952Z",
    fill: "#0085FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6448 18.6991H19.1016C18.111 18.6991 17.3081 19.5137 17.3081 20.519C17.3081 21.5241 18.1109 22.3389 19.1016 22.3389H34.6448C35.6353 22.3389 36.4382 21.5242 36.4382 20.519C36.4382 19.5137 35.6353 18.6991 34.6448 18.6991Z",
    fill: "#0085FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.868 0.5H11.5572C10.5802 0.5 9.78822 1.2789 9.78822 2.24003V18.654H6.66311C2.98893 18.654 0 21.5945 0 25.2079V34.8939C0 38.5079 2.98893 41.4479 6.66311 41.4479C6.9638 41.4479 7.25987 41.4281 7.5494 41.3899H36.7356C41.092 41.3899 44.637 37.9035 44.637 33.618V2.24003C44.637 1.2789 43.8451 0.5 42.868 0.5ZM9.78831 34.8939C9.78831 36.3851 8.70272 37.6321 7.26815 37.9098H6.6632V37.9678C4.93962 37.9678 3.538 36.5886 3.538 34.8938V25.2079C3.538 23.5132 4.94023 22.1339 6.6632 22.1339H9.7884V34.8939H9.78831ZM41.099 33.6179C41.099 35.9443 39.1013 37.9098 36.7356 37.9098H12.5779C13.0561 37.0068 13.3262 35.9807 13.3262 34.8939V3.97997H41.099V33.6179Z",
    fill: "#0085FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3195 26.8886H18.9611C18.0481 26.8886 17.3081 27.7033 17.3081 28.7085C17.3081 29.7137 18.048 30.5284 18.9611 30.5284H29.3195C30.233 30.5284 30.9725 29.7138 30.9725 28.7085C30.9724 27.7033 30.2325 26.8886 29.3195 26.8886Z",
    fill: "#0085FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7998 37.1256C52.7998 43.4075 47.7017 48.5 41.4129 48.5C35.124 48.5 30.0259 43.4075 30.0259 37.1256C30.0259 30.8437 35.124 25.7512 41.4129 25.7512C47.7017 25.7512 52.7998 30.8437 52.7998 37.1256Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4129 45.7701C46.1924 45.7701 50.067 41.8999 50.067 37.1256C50.067 32.3513 46.1924 28.481 41.4129 28.481C36.6333 28.481 32.7588 32.3513 32.7588 37.1256C32.7588 41.8999 36.6333 45.7701 41.4129 45.7701ZM41.4129 48.5C47.7017 48.5 52.7998 43.4075 52.7998 37.1256C52.7998 30.8437 47.7017 25.7512 41.4129 25.7512C35.124 25.7512 30.0259 30.8437 30.0259 37.1256C30.0259 43.4075 35.124 48.5 41.4129 48.5Z",
    fill: "#0085FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4382 36.4431L40.5375 40.5379L46.9143 33.7133",
    stroke: "#0085FF",
    strokeWidth: 2.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReported);
export default __webpack_public_path__ + "static/media/Reported.c5a4660683c1dc89d742903d21b22c02.svg";
export { ForwardRef as ReactComponent };